
import { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";
import MainWebHeader from '../mainwebheader';
import { AxiosInstance, AxiosInstanceWithCache } from '../utils';

 function Header({eventInfo}:any) {
     const [responsiveMenu, setResponsiveMenu] = useState(false);
      const [events, setEvents] = useState<any[]>([]);
      const [additionalPages, setAdditionalPages] = useState<any[]>([]);
       useEffect(() => {
    const fetchPages = async () => {
      if (!eventInfo?.eventcode) return;
      try {
        const response = await AxiosInstanceWithCache.get('/api/getadditionalpages?eventcode=' + eventInfo.eventcode);
        if (response.data.result === 'Success') {
          setAdditionalPages(response.data.data || []);
        }
      } catch (error) {
        console.error('Error fetching additional pages:', error);
      }
    };

    fetchPages();
  }, [eventInfo?.eventcode]);
     const onClickHandler = (e)=>{
        setResponsiveMenu(!responsiveMenu);
     };
       useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstanceWithCache.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);
     return (
         <>
           <MainWebHeader events={events} />
         <header className="fixed animated slideDown">
        <div className="container">
            <div className="header-content">
                <div className="row">
                    <div className="col-lg-2 col-md-6 col-sm-6 col-10">
                        <div className="logo">
                           <a href={"/"} > <div className="sec-title">
                            <img src="/images/bb.png" />
                            </div></a>
                             {/*   <!--sec-title end-->  */}
                        </div> {/*  <!--logo end-->  */}
                    </div>
                    <div className="col-lg-10 col-md-6 col-sm-6 col-2">
                        <nav>
                            <ul>
                                <li><a href={`/event/${eventInfo?.eventcode}`} title="">Home</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/schedule`}title="">Agenda</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/speakers`} title="">Speakers</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/sponsors`} title="">Sponsors</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/partners`} title="">Partners</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/register`} title="">Register</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/location`} title="">Venue</a></li>
                                <li><a href={`/event/${eventInfo?.eventcode}/awards`} title="">Awards</a></li>
                                {additionalPages.map((page) => (
                                    <li key={page.id}><a href={`/event/${eventInfo?.eventcode}/page/${page.pagename.toLowerCase()}`} title="">{page.displaylinkname || page.pagename}</a></li>
                                ))}
                                {eventInfo?.eventcode === 'acsc2026' && (
                                    <li><a href={`/event/${eventInfo?.eventcode}/emergex`} title="">EmergeX</a></li>
                                )}
                            </ul>
                        </nav>
                        <div className={"menu-btn" + (responsiveMenu ? " active ":"")} onClick={onClickHandler}>
                            <span className="bar1"></span>
                            <span className="bar2"></span>
                            <span className="bar3"></span>
                        </div> {/* <!--menu-btn end--> */}
                    </div>
                </div>
            </div> {/* <!--header-content end--> */}
        </div>
    </header> {/* <!--header end--> */}


    <div className={"responsive-mobile-menu" + (responsiveMenu ? " active ":"")}>
        <ul>
            <li><a href={`/event/${eventInfo?.eventcode}`} title="">Home</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/schedule`} title="">Agenda</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/speakers`} title="">Speakers</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/sponsors`} title="">Sponsors</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/partners`} title="">Partners</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/register`} title="">Register</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/location`} title="">Venue</a></li>
            <li><a href={`/event/${eventInfo?.eventcode}/awards`} title="">Awards</a></li>
             {additionalPages.map((page) => (
                                    <li key={page.id}><a href={`/event/${eventInfo?.eventcode}/page/${page.pagename.toLowerCase()}`} title="">{page.displaylinkname || page.pagename}</a></li>
                                ))}
             {eventInfo?.eventcode === 'acsc2026' && (
                                    <li><a href={`/event/${eventInfo?.eventcode}/emergex`} title="">EmergeX</a></li>
                                )}
        </ul>
    </div> {/* <!--responsive-mobile-menu end--> */}
         </>
     );
 }

 export {Header}